import { t } from 'i18next'

import { CAPMPAIGNS_FILTERS_KEYS, WALLET_TYPE_OPTIONS } from '../constants'

export const walletType = {
  keyState: CAPMPAIGNS_FILTERS_KEYS.walletType,
  placeholder: t('rm:wallet.movimentations.filter.type'),
  options: WALLET_TYPE_OPTIONS
}
